import "bootstrap/dist/css/bootstrap.min.css";
import webinar from "../../img/TAROT-WEBINAR-BANNER.png";
import "./webinar.css";
const Webinar = () => {
  return (
    <>
      <section className=" spacing mb-4 mobile-spacing mt-lg-3 webinar-section bg-light">
        <div className="container-fluid py-lg-4 book-section">
          <div className="row py-4">
            <div className="col-lg-6">
              <img
                src={webinar}
                alt="Webinar"
                className="img-fluid object-fit-fill book-image mb-lg-0 mb-3 w-100 "></img>
            </div>

            <div className="col-lg-6 main-heading">
              <h2>Tarot Webinar</h2>
              <p><strong>This FREE Live Tarot Webinar </strong> is designed to help you gain clear answers
                to your most important life questions through the wisdom of Tarot. In this interactive live session, Dr. Surabhi Bhatnagar offers real-time predictions, live question answers and practical remedies focused
                on youth development, career direction and marriage insights.</p>

              <p>

                Participants experience personalized revelations as Tarot cards are drawn live to address individual
                concerns, ensuring meaningful guidance and immediate clarity.
              </p>
              <div className="d-flex align-items-left justify-content-left read-more mt-3 gap-3">
                <a href="https://sbias.blessingsastrology.com/tarot-webinar">Know More</a>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Webinar;
